export const dict = {
  fr: {
    titre: "Où êtes-vous?",
    infos: "+ d'infos",
    services: "Réseau dynamique",
    finddirections: "Obtenir l'itinéraire",
    nostores: "",
    nostoresarea: "Il n'y a pas de concessionnaire dans les environs.",
    directions: "Itinéraire",
    close: "",
    zoomhere: "Zoomer ici",
    print: "Imprimer l'itinéraire",
  },
  en: {
    titre: "Find a distributor?",
    infos: "More infos",
    services: "Dynamic network",
    finddirections: "Find directions",
    nostores: "There are no distributor in this area. However, distributors closest to you are listed below.",
    nostoresarea: "There are no distributor in this area.",
    directions: "Directions",
    close: "",
    zoomhere: "Zoom Here",
    print: "Print directions",
  },
};
